import { ControlFacet } from '../models/controls/ControlFacet';

export interface IMobileOpenControlProps {
    itemKey: string;
}

export interface IMobileOpenOverrides {
    mobileOpenProperty: {[key: string]: string };
}

export const mobileOpenControl: ControlFacet<IMobileOpenControlProps, IMobileOpenOverrides> = new ControlFacet('mobileOpenControl');
